import React from 'react'
import { AppContext } from '../../context'

const ProfileControl: React.FC = ({}) => {
  return (
    <AppContext.Consumer>
      {({
        activePopover,
        onTogglePopover,
        setResetHighlightedPin,
        userHasDismissedCompleteProfilePopup,
        isProfileCompleted
      }) => {
        const isActive = activePopover === 'profile'

        return (
          <div
            title="Profile"
            aria-label="Profile"
            className="mapboxgl-ctrl user-profile"
            onClick={() => {
              if (isActive) {
                setResetHighlightedPin(true)
                onTogglePopover('')
              } else {
                onTogglePopover(
                  isProfileCompleted ? 'profile' : 'complete-profile'
                )
              }
            }}
          >
            <div
              className={`mapboxgl-ctrl-user-profile material-icons ${
                isActive ? 'on' : ''
              }`}
            >
              person
            </div>
            {userHasDismissedCompleteProfilePopup && !isProfileCompleted && (
              <span
                id="complete-your-profile-badge"
                className="badge badge-danger"
                style={{ display: 'inline' }}
              >
                !
              </span>
            )}
          </div>
        )
      }}
    </AppContext.Consumer>
  )
}

export default ProfileControl
